import { createSlice } from "@reduxjs/toolkit";

import { IIAMetricsSlice } from "../../models/admin/InsureAssistPerformance/InsureAssistPerformance";
import {
  getAllIAMetrics,
  getIAMetricsByFilter,
} from "./InsureAssistPerformanceActions";

const initialState: IIAMetricsSlice = {
  highTokenUsage: [],
  highLatency: [],
};

const insureAssistPerformanceMetricsSlice = createSlice({
  name: "insureAssistPerformanceMetrics",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllIAMetrics.fulfilled, (state, { payload }) => {
      state.highTokenUsage = payload?.data?.highTokenUsage;
      state.highLatency = payload?.data?.highLatency;
    });
    builder.addCase(getIAMetricsByFilter.fulfilled, (state, { payload }) => {
      state.highTokenUsage = payload?.data?.highTokenUsage;
      state.highLatency = payload?.data?.highLatency;
    });
  },
});

export default insureAssistPerformanceMetricsSlice.reducer;
